export default __webpack_public_path__ + "2cc953abdd7c06bc03c56d0b49d9d505.png";